module.exports = __webpack_public_path__ + "static/media/email.17a98e09.png";